import { render, staticRenderFns } from "./border-box-case.vue?vue&type=template&id=bde7ea7a&scoped=true"
import script from "./border-box-case.vue?vue&type=script&lang=js"
export * from "./border-box-case.vue?vue&type=script&lang=js"
import style0 from "./border-box-case.vue?vue&type=style&index=0&id=bde7ea7a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bde7ea7a",
  null
  
)

export default component.exports